import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import './Confirmation.css';

const ConfirmationDialog = ({ open, onClose, onConfirm, title, message }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '8px' 
        }
      }}
      BackdropProps={{
        className: 'confirmation-backdrop',
      }}
    >
      <DialogTitle className="confirmation-title">
        {title}
      </DialogTitle>
      <DialogContent className="confirmation-content">
        {message}
      </DialogContent>
      <DialogActions className="confirmation-actions">
        <Button
          onClick={onClose}
          className="confirmation-button cancel-button">
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          className="confirmation-button confirm-button">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
